export const markup = `
    <div class="content video-message-record-overlay">
        <video autoplay muted playsinline class="video-message-record-overlay__video-src" id="video-message-record-overlay__video-src"></video>
        <div class="video-message-record-overlay__rec-label">
            <link
                rel="widget"
                href="/stylist"
                data-args="event.video-message-recorder.state.VIDEOMESSAGE_RECORD_IN_PROGRESS, event.video-message-recorder.state.INITIAL, video-message-record-overlay__rec-label_visible"
            />
            <link rel="widget" href="/stylist" data-args=", event.video-message-recorder.state.VIDEOMESSAGE_RECORD_SUBMIT, video-message-record-overlay__rec-label_visible" />

            <div class="icon-rec-flashlight"></div>
            <span>Rec</span>
        </div>
        <div class="video-message-record-overlay__buttons-container buttons-container">
            <div class="buttons-container__group">
                <link
                    rel="widget"
                    href="/stylist"
                    data-args="event.video-message-recorder.state.INITIAL, event.video-message-recorder.state.VIDEOMESSAGE_RECORD_IN_PROGRESS, buttons-container__group_active"
                />
                <link rel="widget" href="/stylist" data-args=", event.video-message-recorder.state.VIDEOMESSAGE_RECORD_SUBMIT, buttons-container__group_active" />
                <button id="video-message-record-overlay__button_action-take-photo" class="buttons-container__button" >
                    <link rel="l10n" href="/texts/chat/man-chat#localization-media-message-action-take-photo" />
                </button>
                <button id="video-message-record-overlay__button_action-take-video" class="buttons-container__button" >
                    <link rel="l10n" href="/texts/chat/man-chat#localization-media-message-action-take-video" />
                </button>
            </div>
            <div class="buttons-container__group">
                <link
                    rel="widget"
                    href="/stylist"
                    data-args="event.video-message-recorder.state.VIDEOMESSAGE_RECORD_IN_PROGRESS, event.video-message-recorder.state.INITIAL, buttons-container__group_active"
                />
                <link rel="widget" href="/stylist" data-args=", event.video-message-recorder.state.VIDEOMESSAGE_RECORD_SUBMIT, buttons-container__group_active" />
                <button class="buttons-container__button" id="video-message-record-overlay__button_action-stop-video" >
                    <link rel="l10n" href="/texts/chat/man-chat#localization-media-message-action-stop-video" />
                </button>
            </div>
            <div class="buttons-container__group">
                <link
                    rel="widget"
                    href="/stylist"
                    data-args="event.video-message-recorder.state.VIDEOMESSAGE_RECORD_SUBMIT, event.video-message-recorder.state.INITIAL, buttons-container__group_active"
                />
                <link rel="widget" href="/stylist" data-args=", event.video-message-recorder.state.VIDEOMESSAGE_RECORD_IN_PROGRESS, buttons-container__group_active" />
                <button class="buttons-container__button" id="video-message-record-overlay__button_action-cancel-recording">
                    <link rel="l10n" href="/texts/chat/man-chat#localization-media-message-action-cancel-video" />
                </button>
                <button class="buttons-container__button" id="video-message-record-overlay__button_action-proceed-recording">
                    <link rel="l10n" href="/texts/chat/man-chat#localization-media-message-action-send-video" />
                </button>
            </div>
        </div>
    </div>
`;
